import { ReactNode, forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { ModalBackground, ModalContainer, ModalContainerCus, ModalWrapper} from "./Modal.styled";
import { gsap } from "gsap";
import { DisableScroll, EnableScroll } from "@utils/scrollController";

interface IProps {
    children: ReactNode,
    backColor?:string,
    clickOutside?:boolean,
    onClose:(boolean) => void,
    fadeTop?:boolean,
    stickBottom?:boolean,
    Placement?:{width:string, height:string, top:string, left:string};
    animateMiddel?: boolean,
}

const Modal = forwardRef((props:IProps, ref) =>{
    const [domReady, setDomReady] = useState(false)
    const wrapperRef = useRef<HTMLDivElement>(null);
    const bgRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setDomReady(true)
        DisableScroll()
        return () => {
            EnableScroll()
        }
    }, [])

    useEffect(() => {
        if(domReady){
            gsap.to(bgRef.current, {opacity:1, duration: 0.6});
            gsap.to(containerRef.current, { y: 0, opacity:1, duration: 0.8});

            if(props.animateMiddel){
                gsap.to(containerRef.current, { y: 0, opacity:1, scale: 1, duration: 0.8});
            } else {
                gsap.to(containerRef.current, { y: 0, opacity:1, duration: 0.8});
            }
        } 
    }, [domReady])

    useImperativeHandle(ref, () => ({
        handleClose() {
            gsap.to(bgRef.current, {opacity:0}).duration(0.6);
            if(props.animateMiddel){
                gsap.to(containerRef.current, { scale: 0, opacity:0}).duration(0.6).then(Close);
            }else {
                gsap.to(containerRef.current, { y: props.fadeTop?-30:30, opacity:0}).duration(0.6).then(Close);
            }
        }
    }));

    const handleCloseClick = () => {
        gsap.to(bgRef.current, {opacity:0}).duration(0.6);
        if(props.animateMiddel){
            gsap.to(containerRef.current, { scale: 0, opacity:0}).duration(0.6).then(Close);
        }else {
            gsap.to(containerRef.current, { y: props.fadeTop?-30:30, opacity:0}).duration(0.6).then(Close);
        }
    };

    const Close = () => {
        props.onClose(false)
    }

    const modalContent = (
        <ModalWrapper placement={props.Placement} ref={wrapperRef}>
            <ModalBackground ref={bgRef} onClick={() => !props.clickOutside && handleCloseClick()} $backColor={props.backColor?props.backColor:null} />
            {props.animateMiddel?
            <ModalContainerCus ref={containerRef} >
                {props.children}
            </ModalContainerCus>
            :
            <ModalContainer stickBottom={props.stickBottom} fadeTop={props.fadeTop} ref={containerRef} >
                {props.children}
            </ModalContainer>}
        </ModalWrapper>
    )

    return (domReady
        ? ReactDOM.createPortal(modalContent, document.getElementById("modalRoot"))
        : null
    )
})

Modal.displayName = "Modal";

export default Modal;

